import Smartphones from 'Events/EventsImport/views/containers/Smartphones'
import Tablets from 'Events/EventsImport/views/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const EventsImportView = getCurrentDeviceView(Smartphones, Tablets)

export default EventsImportView
